import { IConfiguration, IOrder, isStockSaleOrderToBeProcessed } from 'next-common';
import { get } from 'lodash';

export const getStockSaleParams = (order: IOrder) => {
  return {
    source: get(order, 'lead.source', ''),
    serialNo: get(order, 'vehicles[0].serialNo', null),
    make: get(order, 'lead.make', ''),
    orderType: get(order, 'lead.orderType', ''),
  };
};

export const isValidStockSaleOrder = (order: IOrder, configuration: IConfiguration) => {
  const params = getStockSaleParams(order);
  const isStockSaleOrder = isStockSaleOrderToBeProcessed(
    configuration,
    params?.source,
    params?.serialNo,
    params?.make,
    { orderType: params?.orderType, make: params?.make }
  );
  return isStockSaleOrder;
};
